module.exports = __webpack_public_path__ + "img/AUTO_ACTIVITE_EXT_OUI.92ea53d0.svg";